module.exports = __webpack_public_path__ + "static/media/Modelo_Destaque Atvos_Iniciativas Corporativas.2a631dd7.docx";